import { Label, Responsive, UIHeading3, UIHeading4 } from '@cian/ui-kit';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NewbuildingPrice.css';

export interface INewbuildingPriceProps {
  priceText: string;
  isBooked: boolean;
}

export function NewbuildingPrice({ priceText, isBooked }: INewbuildingPriceProps): JSX.Element {
  return (
    <div className={styles.container}>
      <div>
        <Responsive desktop tablet>
          <UIHeading4 color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>{priceText}</UIHeading4>
        </Responsive>
        <Responsive phone>
          <UIHeading3 color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>{priceText}</UIHeading3>
        </Responsive>
      </div>
      {isBooked && (
        <Label
          background="brand-mauve"
          color="decorative-magentum"
          data-testid="booked-label"
          icon={<IconFunctionalLock16 color="decorative-magentum" />}
        >
          Забронирована
        </Label>
      )}
    </div>
  );
}
